export const messages = {
  en: {
    carInManage: {
      searchCondition: 'Search Conditions',
      inputPlateNumber: 'Please enter license plate number',
      selectVehicleStatus: 'Please select vehicle status',
      inStatus: 'Entry Status',
      paymentComplete: 'Payment Completed',
      exitStatus: 'Exit Status',
      timeoutRepayment: 'Payment Timeout Repayment',
      selectPlateType: 'Please select license plate type',
      temporaryVehicle: 'Temporary Vehicle',
      forSaleVehicle: 'For Sale Vehicle',
      monthlyRental: 'Monthly Rental',
      whitelist: 'Whitelist',
      blacklist: 'Blacklist',
      internalVehicle: 'Internal Vehicle',
      freeVehicle: 'Free Vehicle',
      enterStartTime: 'Enter start time',
      enterEndTime: 'Enter end time',
      search: 'Search',
      reset: 'Reset',
      parkedVehicles: 'Parked Vehicles',
      inoutId: 'In/Out ID',
      vehicleStatus: 'Vehicle Status',
      plateNumber: 'License Plate',
      parkingLot: 'Parking Lot',
      billingRule: 'Billing Rule',
      plateType: 'License Plate Type',
      entryTime: 'Entry Time',
      parkingDuration: 'Parking Duration',
      parkingFee: 'Parking Fee',
      hour: 'hour',
      minute: 'min'
    }
  },
  zh: {
    carInManage: {
      searchCondition: '查询条件',
      inputPlateNumber: '请输入车牌号',
      selectVehicleStatus: '请选择车辆状态',
      inStatus: '进场状态',
      paymentComplete: '支付完成',
      exitStatus: '离场状态',
      timeoutRepayment: '支付超时重新支付',
      selectPlateType: '请选择车牌类型',
      temporaryVehicle: '临时车',
      forSaleVehicle: '出售车辆',
      monthlyRental: '月租车',
      whitelist: '白名单',
      blacklist: '黑名单',
      internalVehicle: '内部车',
      freeVehicle: '免费车',
      enterStartTime: '进场开始时间',
      enterEndTime: '进场结束时间',
      search: '查询',
      reset: '重置',
      parkedVehicles: '在场车辆',
      inoutId: '进出场ID',
      vehicleStatus: '车辆状态',
      plateNumber: '车牌号',
      parkingLot: '停车场',
      billingRule: '计费规则',
      plateType: '车牌类型',
      entryTime: '进场时间',
      parkingDuration: '在场时间',
      parkingFee: '停车费用',
      hour: '小时',
minute: '分'
    }
  },
  'zh-TW': {
    carInManage: {
      searchCondition: '查詢條件',
      inputPlateNumber: '請輸入車牌號',
      selectVehicleStatus: '請選擇車輛狀態',
      inStatus: '進場狀態',
      paymentComplete: '支付完成',
      exitStatus: '離場狀態',
      timeoutRepayment: '支付超時重新支付',
      selectPlateType: '請選擇車牌類型',
      temporaryVehicle: '臨時車',
      forSaleVehicle: '出售車輛',
      monthlyRental: '月租車',
      whitelist: '白名單',
      blacklist: '黑名單',
      internalVehicle: '內部車',
      freeVehicle: '免費車',
      enterStartTime: '進場開始時間',
      enterEndTime: '進場結束時間',
      search: '查詢',
      reset: '重設',
      parkedVehicles: '在場車輛',
      inoutId: '進出廠ID',
      vehicleStatus: '車輛狀態',
      plateNumber: '車牌號',
      parkingLot: '停車場',
      billingRule: '計費規則',
      plateType: '車牌類型',
      entryTime: '進場時間',
      parkingDuration: '在場時間',
      parkingFee: '停車費用',
      hour: '小時',
      minute: '分'
    }
  }
}